import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Nav2 from '../../Nav2/Nav2';
import BannerKemanusiaan from '../CategoryBanner/bannerkemanusiaan';
import Content from '../Content/Content';
import '../Pendidikan/category.css'




const Kemanusiaan = () => {
    const [content, setContent] = useState([])

    const fetchKemanusiaan = async () => {
        const { data } = await axios.get(
            'https://weshare-heroku.herokuapp.com/api/weShare/category/'
        )
        setContent(data.data[3].OpenDonations)
    }

    useEffect(() => {
        fetchKemanusiaan()
    }, [])

    return (
        <div>
            <Nav2 />
            <BannerKemanusiaan />
            <div className="title-category">
                <div className="kemanusiaan">
                    {
                        content && content.map((c) => (
                            <Content
                                key={c.id}
                                name={c.donationName}
                                need={c.donationNeeded}
                                expired={c.expiredDate}
                                image={c.image}
                            />
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default Kemanusiaan;
